exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-headline[data-v-8798fe6e] {\n  border-bottom: 3px dotted #4F842C;\n  padding-bottom: 0.5rem;\n}\n.edit[data-v-8798fe6e] {\n  cursor: pointer;\n}\n.edit[data-v-8798fe6e]:hover {\n  color: #c21924;\n}", ""]);

// exports
